export const SET_STEP = "SET_STEPS";
export const SET_SITE = "SET_SITE";
export const SHOW_ERROR = 'SHOW_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const SHOW_MODAL = 'SHOW_MODAL';
export const HIDE_MODAL = 'HIDE_MODAL';
export const SET_PAYNOW_AVAILABLE = "SET_PAYNOW_AVAILABLE";
export const SET_SYSTEM_AVAILABLE = "SET_SYSTEM_AVAILABLE";

export interface SystemType {
    site: string,
    step: number,
    spinner: boolean,
    showModal: boolean,
    modal?: ModalType,
    onClose?: any,
    showError: boolean,
    paynowAvailable: boolean,
    errors: string[],
    systemAvailable: boolean
}

export interface ModalType {
    icon?: any
    title?: string
    content?: any
    primaryAction?: {
        label: string,
        onClick: any
    },
    secondaryAction?: {
        label: string
        onClick: any
    },
    tertiaryAction?: {
        label: string
        onClick: any
    }
}

interface SetStep {
    type: typeof SET_STEP
    step: number
}

interface ShowError {
    type: typeof SHOW_ERROR
    errors: string[]
}

interface ClearError {
    type: typeof CLEAR_ERROR
}

interface ShowSpinner {
    type: typeof SHOW_SPINNER
}

interface HideSpinner {
    type: typeof HIDE_SPINNER
}

interface SetPayNowAvailable {
    type: typeof SET_PAYNOW_AVAILABLE
}

interface ShowModal {
    type: typeof SHOW_MODAL
    data: ModalType
}

interface HideModal {
    type: typeof HIDE_MODAL
}

interface SetSite {
    type: typeof SET_SITE
    step: number
}

interface SetSystemAvailable {
    type: typeof SET_SYSTEM_AVAILABLE
}


export type ActionType = SetStep | ShowError | ClearError | ShowSpinner | HideSpinner | SetPayNowAvailable | ShowModal | HideModal | SetSite | SetSystemAvailable;
